<template>
  <div class="app-sim-card-delivered">
    <slot name="txtBefore"></slot>
    <b-row class="">
      <b-col class="button">
        <b-overlay :show="loading" spinner-small>
          <b-button type="button" variant="primary" @click="activate">
            <slot name="btnLabel"></slot>
          </b-button>
        </b-overlay>
      </b-col>
    </b-row>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>

import { mapActions } from 'vuex'
import transaction from '../../../../../../mixins/transaction'

export default {
  name: 'SimDelivered',
  mixins: [
    transaction('activateSimCard')
  ],
  data () {
    return {
      loading: false
    }
  },
  computed: {
  },
  methods: {
    activate () {
      this.loading = true
      this.activateSim()
        .then(() => {
          this.loading = false
        }, () => {
          this.loading = false
        })
    },
    ...mapActions('substituteSimCard', [
      'activateSim'
    ])
  }
}
</script>
